/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class FinanceRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      accounts: this.store.query('finance/account', { includeFormer: true }),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      ledgers: this.store.findAll('finance/ledger'),
      ledgerItems: this.store.findAll('finance/ledger-item'),
    });
  }

  activate() {
    if (!isEmpty(this.controller)) {
      this.controller.reset();
    }
  }
}
